import { Spinner } from '@pms-digital/design-system';

interface ChargementPanneauProps {
  children: string;
}

/** What a column of a tab says while Tahiti is being read: a status, announced once. */
export function ChargementPanneau({ children }: ChargementPanneauProps) {
  return (
    <output className="mt-3 flex items-center gap-3 px-1 py-4 text-body text-gray-700">
      <Spinner size="xs" label="" />
      {children}
    </output>
  );
}
